import VadiguAppointmentsView from "@/components/appointment/VadiguAppointmentsView";
import AppointmentsView from "@/components/appointment/AppointmentsView";
import AgendasView from "@/components/appointment/AgendasView";
import ScheduleView from "@/components/appointment/ScheduleView";
import AppointmentsRelocationView from "@/components/appointment/AppointmentsRelocationView";
import AppointmentCancel from "@/components/appointment/AppointmentCancel";
import PatientAppointmentView from "@/components/patient/PatientAppointmentView";
import { isAppointmentRelocationHiddenForBackoffice } from "@/services/config";
import store from "@/store";

const canAccessAppointmentRelocation = () => {
  if (store.getters.isPatient) return false;
  if (
    isAppointmentRelocationHiddenForBackoffice &&
    (store.getters.isAdmin ||
      store.getters.isDoctor ||
      store.getters.isAssistant ||
      store.getters.isManager)
  ) {
    return false;
  }
  return true;
};

const appointmentsEngine = {
  albya: VadiguAppointmentsView,
  default: AppointmentsView,
};

const appointmentRoutes = [
  {
    path: "/appointment/calendar",
    name: "appointment-calendar",
    // component: appointmentsEngine[theme] || appointmentsEngine.default,
    component: appointmentsEngine.default,
  },
  {
    path: "/appointment/:appointmentId/cancel",
    name: "appointment-cancel",
    component: AppointmentCancel,
  },
  {
    path: "/appointment/agendas",
    name: "appointment-agendas",
    component: AgendasView,
  },
  {
    path: "/appointment/relocation",
    name: "appointment-relocation",
    meta: {
      condition: canAccessAppointmentRelocation,
      redirectTo: { name: "home" },
    },
    component: AppointmentsRelocationView,
  },
  {
    path: "/appointment/schedule",
    name: "appointment-schedule",
    component: ScheduleView,
  },
  // {
  //   path: "/appointment/patient",
  //   name: "appointment-patient",
  //   component: PatientAppointmentsView,
  // },
  {
    path: "/appointment/:appointmentId",
    name: "appointment",
    component: PatientAppointmentView,
  },
];

export default appointmentRoutes;
